import React from 'react';
import {useNotifications} from "context/NotificationContext";
import Notification from "components/Notification";

const types: Record<string, number> = {
    "info": Notification.types.INFO,
    "success": Notification.types.SUCCESS,
    "warning": Notification.types.WARNING,
    "error": Notification.types.ERROR,
}

function NotificationCentre() {
    const {notifications} = useNotifications()

    return (
        <div aria-live="assertive" className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-20">
            <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
                {notifications.map((notification) => (
                    <Notification key={notification.id} type={types[notification.type]} title={notification.title} duration={notification.duration} >
                        {notification.body}
                    </Notification>
                ))}
            </div>
        </div>
    );
}

export default NotificationCentre;